<template>
  <basic-container id="parkblacklist20220108">
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="startDateRangeSearch">
        <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.startDateRangeString1"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.startDateRangeString2"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="endDateRangeSearch">
        <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.endDateRangeString1"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.endDateRangeString2"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="menuLeft">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.addBatchBtn"
          @click="openFormDialog()"
        >批 量 新 增
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkblacklist_delete"
          @click="handleDelete"
          >删 除
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-top"
          plain
          v-if="permissionList.syncBtn"
          @click="handleSync"
          >同步下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-s-operation"
          plain
          v-if="permissionList.DelayBtn"
          @click="handleDelay"
        >延期
        </el-button>
        <el-button
        type="primary"
        size="small"
        icon="el-icon-upload"
        plain
        v-if="permissionList.importBtn"
        @click="handleImport"
      >批量导入
      </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload"
          plain
          v-if="permissionList.exportBtn"
          @click="handleExport"
        >导出
        </el-button>
      </template>
    </avue-crud>
    <addBlackWhiteCarPlusForm ref="addBlackWhiteCarPlusForm" @onLoad="onLoad"></addBlackWhiteCarPlusForm>
    <el-dialog
      id="delayDialog"
      title="延期"
      :visible.sync="showDelayDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="delayDialog"
          v-model="delayForm"
          :option="delayOption"
          @submit="submitDelay"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button icon="el-icon-back" @click="cancelDelay">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      id="importDialog"
      title="导入"
      :visible.sync="showImportDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="delayDialog"
          v-model="importForm"
          :option="importOption"
          @submit="submitImport"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button icon="el-icon-download" @click="downExcel" v-show="permissionList.downloadBtn">模板下载</el-button>
            <el-button icon="el-icon-close" @click="cancelImport">关闭</el-button>
          </template>
          <template slot="fileName" slot-scope="scope">
            <el-upload
              accept=".xls,.xlsx"
              limit="1"
              style="display: inline-block; vertical-align: top;"
              ref="upload"
              action=""
              :auto-upload="false"
              :http-request="uploadFile"
              :on-change="changeFile"
              :on-remove="removeFile"
            >
              <el-button size="small" type="primary">请选择文件</el-button>
            </el-upload>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  syncBlacklist,
  delayBlacklist,
  submitImportFile,
} from '@/api/v4ward/park/blacklist/parkblacklist';
import dayjs from 'dayjs';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { nodeTreeByParentId } from '@/api/v4ward/car/carmonth';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
import addBlackWhiteCarPlusForm from "./addBlackWhiteCarPlus-form.vue"

export default {
  data() {
    return {
      reWrite: false,
      spaceList: [],
      tempParkingLotId: '',
      firstDisplayFlag: false,
      showDelayDialogFlag: false,
      showImportDialogFlag: false,
      importDone: null,
      form: {},
      delayForm: {},
      importForm: {},
      query: {
        parkingLotId:"",
        startDateRange:"",
        endDateRange:"",
        plateNumber:"",
        driverName:"",
        startDateRangeString1:"",
        startDateRangeString2:"",
        endDateRangeString1:"",
        endDateRangeString2:'',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      importOption: {
        submitText: '导入',
        emptyBtn: false,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            clearable: false,
            span: 12,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车场区域',
            prop: 'regionIds',
            span: 12,
            multiple: true,
            checkStrictly: true,
            type: 'tree',
            dataType: 'string',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '类型',
            prop: 'blackType',
            span: 12,
            type: 'select',
            value: 0,
            dicData: [
              { label: '白名单', value: 0 },
              { label: '黑名单', value: 1 },
            ],
            rules: [
              {
                required: true,
                message: '请选择名单类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '授权类型',
            prop: 'parkAreaRightType',
            span: 12,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_area_right_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            value: 0,
            display: true,
            rules: [
              {
                required: true,
                message: '请选择授权类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '文件导入',
            prop: 'fileName',
            formslot: true,
            span: 24,
            rules: [{ required: true, message: '请选择导入表格', trigger: 'change',},],
          }
        ],
      },
      delayOption: {
        submitText: '保存',
        emptyBtn: false,
        column: [
          {
            label: '结束时间',
            prop: 'endDate',
            span: 24,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            rules: [
              {
                required: true,
                message: '请选择结束时间',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      option: {
        height: 'auto',
        calcHeight: 55,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        refreshBtn:true,
        selection: true,
        dialogClickModal: false,
        columnBtn: true,
        labelWidth: 90,
        align: 'center',
        indexLabel: '#',
        dialogWidth: '40%',
        span: 24,

        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'tree',
            span: 12,
            searchSpan: 6,
            editDisabled: true,
            search: true,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域',
            prop: 'regionNames',
            span: 12,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: '车场区域',
            prop: 'regionIds',
            span: 12,
            hide: true,
            editDisplay: true,
            addDisplay: true,
            viewDisplay: false,
            multiple: true,
            checkStrictly: true,
            type: 'tree',
            dataType: 'string',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            placeholder: '请输入车牌号',
            search: true,
            span: 12,
            searchSpan: 6,
            maxlength: 8,
            rules: [
              {
                required: true,
                message: '请输入车牌',
                trigger: 'blur',
              },
              {
                required: true,
                pattern: this.$validation.carPlate,
                message: '车牌格式不对',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车主姓名',
            prop: 'driverName',
            placeholder: '请输入车主名称',
            search: true,
            span: 12,
            searchSpan: 6,
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入姓名',
                trigger: 'blur',
              },
              ],
          },
          {
            label: '车主电话',
            prop: 'mobile',
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入手机号码',
                trigger: 'change',
              },
              {
                required: true,
                pattern: this.$validation.phone,
                message: '请输入正确的手机号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '单位信息',
            prop: 'companyName',
            span: 12,
            maxlength: 32,
            search: true,
          },
          {
            label: '开始时间',
            prop: 'startDate',
            span: 12,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            rules: [
              {
                required: true,
                message: '请选择开始时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开始时间',
            prop: 'startDateRange',
            span: 24,
            search: true,
            searchRange: true,
            searchslot:true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '结束时间',
            prop: 'endDateRange',
            searchslot:true,
            span: 24,
            search: true,
            searchRange: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '结束时间',
            prop: 'endDate',
            span: 12,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            rules: [
              {
                required: true,
                message: '请选择结束时间',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.startDate);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('结束时间必须大于开始时间！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },

          {
            //0未生效，1生效，2失效
            label: '状态',
            prop: 'status',
            type: 'select',
            hide: true,
            display: false,
            value: 1,
            dicData: [
              { label: '停用', value: 0 },
              { label: '启用', value: 1 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请输入状态',
                trigger: 'change',
              },
            ],
          },

          {
            label: '类型',
            prop: 'blackType',
            span: 12,
            type: 'select',
            value: 0,
            dicData: [
              { label: '白名单', value: 0 },
              { label: '黑名单', value: 1 },
            ],
            rules: [
              {
                required: true,
                message: '请选择名单类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '授权类型',
            prop: 'parkAreaRightType',
            span: 12,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_area_right_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            value: 0,
            display: true,
            rules: [
              {
                required: true,
                message: '请选择授权类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '同步状态',
            prop: 'syncStatus',
            type: 'select',
            dataType: 'number',
            search: true,
            span: 12,
            searchSpan: 6,
            dicUrl: 'api/blade-system/dict/dictionary?code=park_sync_status',
            props: { label: 'dictValue', value: 'dictKey' },
            display: false,
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            span: 24,
            minRows: 2,
            maxlength: 100,
            overHidden: true,
            showWordLimit: true,
          },
          {
            label: '附件',
            prop: 'imgUrl',
            hide: true,
            type: 'upload',
            fileSize: 1024*1024,
            accept:[".jpg",".png"],
            listType: 'picture-img',
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            action: '/api/blade-resource/oss/endpoint/put-file',
            tip: '只能上传jpg/png格式的图片，且不超过1MB',
            span: 12,
            row: true,
            uploadError:(error, column) =>{
              this.$message.error('上传失败，只能上传jpg/png格式的图片，且不超过1MB')
              console.log(error, column)
            },
          }
        ],
      },
      data: [],
    };
  },
  components: {addBlackWhiteCarPlusForm},
  watch: {
    'form.blackType'(val){
      let column = this.findObject(this.option.column,'parkAreaRightType');
      if(0 == val){
        column.display = true;
      }else {
        column.display = false;
      }
    },
    'importForm.blackType'(val){
      let column = this.findObject(this.importOption.column,'parkAreaRightType');
      if(0 == val){
        column.display = true;
      }else {
        column.display = false;
      }
    },
    'form.parkingLotId'() {
      nodeTreeByParentId(this.form.parkingLotId ).then((res) => {
        const column = this.findObject(this.option.column, 'regionIds');

        setTimeout(()=>{
          column.dicData = res.data;
          if (this.vdui.isEmpty(this.form.regionIds) && this.vdui.isNotEmpty(column.dicData)) {
            this.form.regionIds = column.dicData[0].id;
          }
        });
      })
    },
    'importForm.parkingLotId'() {
      nodeTreeByParentId(this.importForm.parkingLotId ).then((res) => {
        const column = this.findObject(this.importOption.column, 'regionIds');
        setTimeout(()=>{
          column.dicData = res.data;
          if (this.vdui.isEmpty(this.importForm.regionIds) && this.vdui.isNotEmpty(column.dicData)) {
            this.importForm.regionIds = column.dicData[0].id;
          }
        });
      })
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkblacklist_add, false),
        viewBtn: this.vaildData(this.permission.parkblacklist_view, false),
        delBtn: this.vaildData(this.permission.parkblacklist_delete, false),
        editBtn: this.vaildData(this.permission.parkblacklist_edit, false),
        syncBtn: this.vaildData(this.permission.parkblacklist_sync, false),
        DelayBtn: this.vaildData(this.permission.parkblacklist_delay, false),
        importBtn: this.vaildData(this.permission.parkblacklist_import, false),
        downloadBtn: this.vaildData(this.permission.parkblacklist_template, false),
        exportBtn: this.vaildData(this.permission.parkblacklist_export, false),
        addBatchBtn: this.vaildData(this.permission.parkblacklist_add_batch, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree(null, 1).then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    openFormDialog(){
      this.$refs.addBlackWhiteCarPlusForm.openDialog();
    },
    uploadFile(f) {
      const formData = new FormData();
      formData.append('parkingLotId', this.importForm.parkingLotId);
      formData.append('regionIds', this.importForm.regionIds);
      formData.append('blackType', this.importForm.blackType);
      formData.append('parkAreaRightType', this.importForm.parkAreaRightType);
      formData.append('file',f.file);
      submitImportFile(formData)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success('导入成功!');
            this.onLoad();
            this.showImportDialogFlag = false;
            this.importDone();
          }
        })
        .catch(({ err }) => {
          console.log(err);
          this.showImportDialogFlag = false;
          this.importDone();
        });
    },
    changeFile(file, fileList) {
      console.log('重选了文件');
      this.importForm.file = file;
      this.importForm.fileName = file.name;
    },
    removeFile(){
      this.importForm.fileName = '';
      this.importForm.file = null;
    },
    submitImport(form, done) {
      this.importDone = done;
      this.$refs.upload.submit();
    },

    cancelImport() {
      console.log('取消');
      this.showImportDialogFlag = false;
    },
    //excel模板导出使用这个方法
    downExcel(){
      import('@/vendor/Export2Excel.js').then((excel) => {
        const tHeader = ['序号','车牌号','车主姓名','车主电话','单位信息','开始时间','结束时间','备注'];
        const data = [['1','鄂A360N1','张三','12343232341','长江物业','2021-05-13','2021-06-13','日期为文本框日期']];
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '黑白名单模板',
        })
      });
    },
    downloadTemplate() {
      const fileName = '黑白名单模板.xls';
      console.log('下载模板...');
      axios
        .get('/api/park/blacklist/template', { responseType: 'blob' }
        )
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          let downloadElement = document.createElement('a');
          downloadElement.href = window.URL.createObjectURL(blob); // 创建一个DOMString
          downloadElement.download = fileName;
          downloadElement.click();
          window.URL.revokeObjectURL(blob); // 释放 DOMString  ,解除内存占用
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleExport() {
      const fileName = '黑白名单'+dayjs().format('YYYY-MM-DD HH:mm:ss')+'.xlsx';
      console.log('下载黑白名单数据...');
      //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
      let parkingLotId = this.query.parkingLotId;
      if (this.vdui.isEmpty(this.query.parkingLotId)) {
        parkingLotId = this.tempParkingLotId;
      }

      let startDateRangeString = "";

      if(this.vdui.isNotEmpty(this.query.startDateRangeString1)&&this.vdui.isNotEmpty(this.query.startDateRangeString2)){
        startDateRangeString = this.query.startDateRangeString1+ ',' +this.query.startDateRangeString2;
      }
      let endDateRangeString = "";

      if(this.vdui.isNotEmpty(this.query.endDateRangeString1)&&this.vdui.isNotEmpty(this.query.endDateRangeString2)){
        endDateRangeString = this.query.endDateRangeString1+ ',' +this.query.endDateRangeString2;
      }
      let plateNumber = this.query.plateNumber;
      if(this.vdui.isEmpty(this.query.plateNumber)){
        plateNumber = "";
      }
      let companyName = this.query.companyName;
      if(this.vdui.isEmpty(this.query.companyName)){
        companyName = "";
      }

      let driverName = this.query.driverName;
      if(this.vdui.isEmpty(this.query.driverName)){
        driverName = "";
      }

      window.open(
        `/api/park/blacklist/export?${
          this.website.tokenHeader
        }=${getToken()}&parkingLotId=${parkingLotId}
        &startDateRangeString=${startDateRangeString}
        &endDateRangeString=${endDateRangeString}
        &companyName=${companyName}
        &plateNumber=${plateNumber}
        &driverName=${driverName}`
      );
    },
    handleDelay() {
      //延期
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.delayForm.ids = this.ids;
      this.delayForm.spaceId = this.query.parkingLotId;
      this.showDelayDialogFlag = true;
    },
    submitDelay(form, done) {
      delayBlacklist(this.delayForm).then(() => {
        this.$message.success('延期成功!');
        this.onLoad();
        this.showDelayDialogFlag = false;
        done();
      },error =>{
        done();
        console.log(error);
      });
    },
    cancelDelay() {
      console.log('取消');
      this.showDelayDialogFlag = false;
    },
    handleImport() {
      //导入
      this.showImportDialogFlag = true;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.importOption.column, 'parkingLotId');
        spaceColumn.dicData = this.spaceList;
        this.importForm.parkingLotId = this.query.parkingLotId;
      }
    },
    handleSync() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定下发所选黑名单车辆信息到对应车场终端?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return syncBlacklist({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    rowSave(row, done, loading) {
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }else if('add' === type){
        const column = this.findObject(this.option.column, 'parkingLotId');
        column.value = this.query.parkingLotId;
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query.plateNumber=params.plateNumber
      this.query.companyName=params.companyName;
      this.query.parkingLotId = params.parkingLotId;
      this.query.driverName = params.driverName;
      this.query.syncStatus = params.syncStatus;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
      if (this.vdui.isEmpty(this.query.parkingLotId)) {
        this.query.parkingLotId = this.tempParkingLotId;
      }
      if(this.vdui.isNotEmpty(this.query.endDateRangeString1)&&this.vdui.isNotEmpty(this.query.endDateRangeString2)){
        this.query.endDateRangeString = this.query.endDateRangeString1 + ',' +this.query.endDateRangeString2;
      }else{
        this.query.endDateRangeString='';
      }
      if(this.vdui.isNotEmpty(this.query.startDateRangeString1)&&this.vdui.isNotEmpty(this.query.startDateRangeString2)){
        this.query.startDateRangeString = this.query.startDateRangeString1+ ',' +this.query.startDateRangeString2;
      }else{
        this.query.startDateRangeString = '';
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style>
  .el-date-editor .el-range-separator{
    width: 10%;
  }
  #delayDialog .el-dialog{
    width: 30%
  }
  #importDialog .el-dialog{
    width: 30%
  }
  .avue-upload--upload .el-upload, .avue-upload--upload .el-upload__tip, .avue-upload__dialog .el-dialog__header {
    display: block;
  }
</style>
<style lang="scss">
#parkblacklist20220108 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
